export default __webpack_public_path__ + "static/media/icon-drilling.d27eeee8.svg";